import { SabreRemarkTypesValues } from '../../constants';

const validateUserRemarks = (userRemarks) => {
  const hasDuplicateUserRemarks = userRemarks && userRemarks.length !== new Set(
    userRemarks.map(({ id, ...rest }) => JSON.stringify(rest)),
  ).size;
  const isUserRemarksValidated = userRemarks
      && userRemarks.every((remark) => Object.entries(remark).every(([key, val]) => {
        if (key === 'id' || key === 'segment' || (key === 'code' && remark.type !== SabreRemarkTypesValues.AlphaCoded)) {
          return true;
        }
        return val.trim() !== '';
      })) && !hasDuplicateUserRemarks; // Ensuring no duplicates

  return isUserRemarksValidated;
};

export default validateUserRemarks;
